export const faqs = [
  {
    q: 'Do I need to be an AI expert?',
    a: [
      'No.',
      'The prompts are designed to be copied, customized and used with your preferred AI assistant. Basic familiarity with tools such as ChatGPT, Claude or Gemini is helpful, but advanced prompt engineering is not required.',
    ],
  },
  {
    q: 'Can I use this with ChatGPT?',
    a: ['Yes. The prompts are designed to work with major general-purpose AI assistants, including ChatGPT, Claude and Gemini. Results can vary between tools and models.'],
  },
  {
    q: 'Can I customize the prompts?',
    a: [
      'Absolutely.',
      'The prompts use bracketed fields such as [CITY], [PROPERTY TYPE], [CLIENT TYPE] and [GOAL] so you can adapt them to your market, business and specific situation.',
    ],
  },
  {
    q: 'Is this only for REALTORS®?',
    a: ['The system is specifically designed around REALTOR® and real estate workflows, so it is particularly relevant to real estate professionals.'],
  },
  {
    q: 'Is this a physical book?',
    a: ['No.', 'THE REALTOR AI PLAYBOOK™ is a digital product delivered in PDF format, designed for access from your laptop, tablet or phone.'],
  },
  {
    q: 'Is this a one-time payment?',
    a: ['Yes.', 'Your purchase provides lifetime access to the digital product, subject to the applicable terms.'],
  },
  {
    q: 'Does AI replace my professional judgment?',
    a: [
      'No.',
      'AI-generated content should always be reviewed and adapted by the real estate professional before being used with clients, listings, advertising or other professional communications.',
      'You remain responsible for complying with applicable laws, brokerage policies, licensing requirements, fair-housing obligations and other professional standards.',
    ],
  },
];
